import React, { useRef, useEffect } from 'react';
import { TweenMax, Power3 } from 'gsap';
import '../styles/Destinations.scss';

const Destinations = () => {
    const destinations = [
        { id: 1, name: "Moon Base Alpha", desc: "The classic lunar getaway. Low gravity, high luxury." },
        { id: 2, name: "Mars Colony", desc: "Red dust, blue sunsets, and adventure awaits." },
        { id: 3, name: "Titan Resort", desc: "Methane lakes and ringside views of Saturn." }
    ];

    let sectionRef = useRef(null);
    let titleRef = useRef(null);
    let cardsRef = useRef([]);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        TweenMax.to(titleRef, 1, {
                            opacity: 1,
                            y: 0,
                            ease: Power3.easeOut
                        });
                        TweenMax.staggerTo(
                            cardsRef.current,
                            0.8,
                            { opacity: 1, y: 0, ease: Power3.easeOut, delay: 0.2 },
                            0.2
                        );
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.2 }
        );

        observer.observe(sectionRef);

        // Initial hidden state set in CSS or via GSAP set here
        TweenMax.set(titleRef, { opacity: 0, y: 50 });
        TweenMax.set(cardsRef.current, { opacity: 0, y: 50 });

        return () => observer.disconnect();
    }, []);

    return (
        <section id="destinations" className="destinations" ref={el => sectionRef = el}>
            <div className="container">
                <h2 className="section-title" ref={el => titleRef = el}>Select Your Destination</h2>
                <div className="destination-grid">
                    {destinations.map((dest, index) => (
                        <div
                            key={dest.id}
                            className="destination-card"
                            ref={el => cardsRef.current[index] = el}
                        >
                            <h3>{dest.name}</h3>
                            <p>{dest.desc}</p>
                            <span className="explore-link">Explore &rarr;</span>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Destinations;
